module.exports = __webpack_public_path__ + "static/media/sonal.4a9b8d9a.png";